module.exports = {
    "url": "https://demo.appmed.me/",
    // "url": "https://app.bewikicare.com.br/",
    // "url": "https://app.anestesiacaf.com.br/",
    // "url": "https://app.hsjtmeleiro.com.br/",
    "versao": "2.0.2",
    "telefone": "tel:51997619480",
    "whatsapp": "https://api.whatsapp.com/send?phone=5551997619480&text=Olá",
    "instagram": "https://instagram.com/baseit",
    "facebook": "https://www.facebook.com/baseit",
    "site": "https://demo.appmed.me/",
    "loginTexto": "Clinic",
    "googleAnalytics": {
        "id": ""
    },
    "pusher": {
        "key": "b60c3a5104cd0d0c43fc"
    },
    "sintomas": {
        "itens": []
    },
    "money": {
        "decimal": ',',
        "thousands": '.',
        "prefix": '',
        "suffix": '',
        "precision": 2,
        "masked": false
    },
    "menuItens": {
        "admin": [
            {
                "nome": "Início",
                "icone": "bs-inicio",
                "rota": "Dashboard",
                "condicao": "true",
                "mostrar": true,
                "inicio": false,
                "sidebar": true,
                "id": "e96dc959fe0d98fdd6855664699473f7"
            },
            {
                "nome": "Formulários",
                "icone": "bs-formularios",
                "rota": "PendentesFormularios",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "0314b8947b60b23ee6a8920c15a69e3b"
            },
            {
                "nome": "Gerenciar Formulários",
                "icone": "bs-gerenciar-formularios",
                "rota": "Formularios",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "0388a6da0668c41b8792081464d0789b"
            },
            {
                "nome": "Relatório de Formulários",
                "icone": "bs-relatorio-formularios",
                "rota": "RelatorioFormularios",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "ffda8bcae62e493dfac7e4b43fd29115"
            },
            {
                "nome": "Pacientes",
                "icone": "bs-pacientes",
                "rota": "Pacientes",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "180d99b53eede430d56d5587728f6c02"
            },
            {
                "nome": "Agendamentos",
                "icone": "bs-meus-agendamentos",
                "rota": "Agendamentos",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "56d37e332c2e65ddfb62fb13097b04b4"
            },
            {
                "nome": "Dicas de Saúde e Bem-Estar",
                "icone": "bs-dicas-saude",
                "rota": "Posts",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "a363dbea5969c2d59f1bfbd87fb2bfe2"
            },
            {
                "nome": "Receitas",
                "icone": "bs-receitas",
                "rota": "Receitas",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "80f74d1e2678dbb20f0973f265d64f5b"
            },
            {
                "nome": "Atestados",
                "icone": "bs-atestados",
                "rota": "Atestados",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "2de1f52af98a15630a2cd0e6a085ee50"
            },
            {
                "nome": "Mural de Recados",
                "icone": "bs-mural-recados",
                "rota": "Mural",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "bb6f760173b7b0de9840cea555937017"
            },
            {
                "nome": "Beira Leito",
                "icone": "bs-beira-leito",
                "rota": "BeiraLeito",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "5665ee74b7fea24a5f7ee6fbacff29e6"
            },
            {
                "nome": "Honorários Médicos",
                "icone": "bs-honorarios-medicos",
                "rota": "HonorariosMedicos",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "b968dae500d72b3711dc45b3bea45802"
            },
            {
                "nome": "Orçamento",
                "icone": "bs-orcamento",
                "rota": "FinanceiroMovimentacoes",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "4f7cc651b94e72a8e2efd2382ceea746"
            },
            {
                "nome": "Aprovações",
                "icone": "bs-aprovacoes",
                "rota": "FinanceiroSolicitacoes",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "30d9a048b83467707bb6b4604756179c"
            },
            {
                "nome": "Chat IA",
                "icone": "bs-chat-ia",
                "rota": "ChatIA",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "af8ec1907c62506d41b808f4b752dec1"
            },
            {
                "nome": "Campanhas",
                "icone": "bs-campanhas",
                "rota": "Campanhas",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "94e62246c6637db7b044dc74b1467c8d"
            },
            {
                "nome": "Usuários",
                "icone": "bs-usuarios",
                "rota": "UsuariosGeral",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "15f6f41f6091c726c5886e2d1020fde3"
            },
            {
                "nome": "Configurações",
                "icone": "bs-configuracoes",
                "rota": "Configuracoes",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "81ff6944d1fc4484e81670f7a9f48218"
            },
            {
                "nome": "Minha Conta",
                "icone": "bs-minha-conta",
                "rota": "Conta",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "518632f11f4cb75a7a21f45461806464"
            },
            {
                "nome": "Acessar Site",
                "tipo": "link",
                "icone": "bs-site",
                "condicao": "true",
                "link": "https://app.appmed.me",
                "mostrar": true,
                "inicio": false,
                "sidebar": true,
                "id": "d01749e46b0b3c4d1973a1b29fcb78cd"
            },
            {
                "nome": "Termos de Uso",
                "tipo": "modal",
                "modal": "modal-termos-de-uso",
                "condicao": "true",
                "icone": "la-file-contract",
                "mostrar": true,
                "inicio": false,
                "sidebar": true,
                "id": "29d5f20dbdbc6d5ea2390925982712b7"
            },
            {
                "nome": "Política de Privacidade",
                "tipo": "modal",
                "modal": "modal-politicas-de-privacidade",
                "condicao": "true",
                "icone": "la-file-invoice",
                "mostrar": true,
                "inicio": false,
                "sidebar": true,
                "id": "93e049e7a82bcd91947b42dd5b91619a"
            },
            {
                "nome": "Sair",
                "tipo": "logout",
                "onclick": "logout",
                "condicao": "this.$root.user.cod",
                "mostrar": true,
                "icone": "bs-sair",
                "inicio": false,
                "sidebar": true,
                "id": "b50fc91b1aba5120c9a615f361400823"
            },
            {
                "nome": "Submenu de testes",
                "icone": "bs-novidades",
                "tipo": "submenu",
                "permissao": [
                    "admin"
                ],
                "itens": [
                    {
                        "nome": "Acessar Site",
                        "tipo": "link",
                        "icone": "bs-site",
                        "condicao": "true",
                        "link": "https://app.appmed.me",
                        "inicio": false,
                        "sidebar": true,
                        "id": "0f15cb3ab90cf21855a196cca289e352"
                    }
                ],
                "onclick": "",
                "rota": "Menu",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "673346fb0de523b202646f87fa183888"
            }
        ],
        "contratante": [
            {
                "nome": "Formulários",
                "icone": "bs-formularios",
                "rota": "PendentesFormularios",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "ca795af6b6cfba9e4d455cf390725d65"
            },
            {
                "nome": "Meus Documentos",
                "icone": "bs-meus-documentos",
                "rota": "Arquivos",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "83d30233ee862d450b3807c9392b0e07"
            },
            {
                "nome": "GED",
                "icone": "bs-meus-documentos",
                "rota": "Ged",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "12a68a30562d3cf2e6316712c0fa151d"
            },
            {
                "nome": "Agendar Serviço",
                "icone": "bs-agendar-servico",
                "rota": "Profissionais",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "b993d7de70ca1f486f1c07f1035e7207"
            },
            {
                "nome": "Agendamentos",
                "icone": "bs-meus-agendamentos",
                "rota": "Agendamentos",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "54b05e418b11a8db55839dabe6164853"
            },
            {
                "nome": "Dicas de Saúde e Bem-Estar",
                "icone": "bs-dicas-saude",
                "rota": "Posts",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "26718123534ffd9d2ad3975d0c969354"
            },
            {
                "nome": "Receitas",
                "icone": "bs-receitas",
                "rota": "Receitas",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "a19a64686c057f8d3928d2c61dc95d1d"
            },
            {
                "nome": "Atestados",
                "icone": "bs-atestados",
                "rota": "Atestados",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "21924d3be88fde1f0954405364f66630"
            },
            {
                "nome": "Meus Exames",
                "icone": "bs-exames",
                "rota": "Exames",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "510faf4113297a1dba14e5e8bf031f08"
            },
            {
                "nome": "Minha Conta",
                "icone": "bs-minha-conta",
                "rota": "Conta",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "100c952b7d7b002e4a78703fb4005468"
            },
            {
                "nome": "Telefone",
                "tipo": "link",
                "icone": "bs-telefone",
                "link": "tel:51997619480",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "fc0e921fd7d88ff9a7ddcc981d1a20df"
            },
            {
                "nome": "WhatsApp",
                "icone": "bs-whatsapp icon-transparent",
                "tipo": "link",
                "link": "https://api.whatsapp.com/send?phone=5551997619480&text=Olá",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": false,
                "id": "bc01269c4e4f880af29cbef9eb88abc4"
            },
            {
                "nome": "Acessar Site",
                "tipo": "link",
                "icone": "bs-site",
                "condicao": "true",
                "link": "https://app.appmed.me",
                "inicio": false,
                "sidebar": true,
                "id": "0f15cb3ab90cf21855a196cca289e352"
            },
            {
                "nome": "Termos de Uso",
                "tipo": "modal",
                "modal": "modal-termos-de-uso",
                "condicao": "true",
                "icone": "la-file-contract",
                "inicio": false,
                "mostrar": true,
                "sidebar": true,
                "id": "70183b81d657aff2bd4e3800eb96e963"
            },
            {
                "nome": "Política de Privacidade",
                "tipo": "modal",
                "modal": "modal-politicas-de-privacidade",
                "condicao": "true",
                "icone": "la-file-invoice",
                "inicio": false,
                "mostrar": true,
                "sidebar": true,
                "id": "f797d8a47b8c54b502585dd7a6360eb8"
            }
        ],
        "profissional": [
            {
                "nome": "Formulários",
                "icone": "bs-formularios",
                "rota": "PendentesFormularios",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "62adfbfcc91ed826cf48ed95075ee2e9"
            },
            {
                "nome": "Relatório de Formulários",
                "icone": "bs-relatorio-formularios",
                "rota": "RelatorioFormularios",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "839d88efb77d605a4eba3a6bd19ec6bd"
            },
            {
                "nome": "Pacientes",
                "icone": "bs-pacientes",
                "rota": "Pacientes",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "942484cb96ed987ce1613fd59f35b4e6"
            },
            {
                "nome": "Agendamentos",
                "icone": "bs-meus-agendamentos",
                "rota": "Agendamentos",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "df8a666cd9c08688d5c064ac4a1bf773"
            },
            {
                "nome": "Beira Leito",
                "icone": "bs-beira-leito",
                "rota": "BeiraLeito",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "695b41d4dbb09fbdb848d85806ad323d"
            },
            {
                "nome": "Receitas",
                "icone": "bs-receitas",
                "rota": "Receitas",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "a1626a67a8ca291e3b5aa8776720277c"
            },
            {
                "nome": "Atestados",
                "icone": "bs-atestados",
                "rota": "Atestados",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "a29120cb47d3a56b6a29c13a62327ff2"
            },
            {
                "nome": "Honorários Médicos",
                "icone": "bs-honorarios-medicos",
                "rota": "HonorariosMedicos",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "a44c8187c567b505e0fcf862c2b976fc"
            },
            {
                "nome": "Minha Conta",
                "icone": "bs-minha-conta",
                "rota": "Conta",
                "condicao": "true",
                "mostrar": true,
                "inicio": true,
                "sidebar": true,
                "id": "2fce6780ad3319f1c0a4fd46b99669b4"
            },
            {
                "nome": "Acessar Site",
                "tipo": "link",
                "icone": "bs-site",
                "condicao": "true",
                "link": "https://app.appmed.me",
                "inicio": false,
                "sidebar": true,
                "id": "e3d9a72b50cd6518ee88d535139c4000"
            },
            {
                "nome": "Termos de Uso",
                "tipo": "modal",
                "modal": "modal-termos-de-uso",
                "condicao": "true",
                "icone": "la-file-contract",
                "inicio": false,
                "mostrar": true,
                "sidebar": true,
                "id": "74ff8e107e5d0152dc644d605b06d1eb"
            },
            {
                "nome": "Política de Privacidade",
                "tipo": "modal",
                "modal": "modal-politicas-de-privacidade",
                "condicao": "true",
                "icone": "la-file-invoice",
                "inicio": false,
                "mostrar": true,
                "sidebar": true,
                "id": "1a1e17b9bda6413997b55898592896ce"
            }
        ],
        "gerente": [
                {
                    "nome": "Formulários",
                    "icone": "bs-formularios",
                    "rota": "PendentesFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "cc67bdeef6fab202b77d924e2f17cc69"
                },
                {
                    "nome": "Relatório de Formulários",
                    "icone": "bs-relatorio-formularios",
                    "rota": "RelatorioFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "4c01db966099d922281a3b2b6b267a70"
                },
                {
                    "nome": "Pacientes",
                    "icone": "bs-pacientes",
                    "rota": "Pacientes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "6fb102e5ffb3d1647ef309f0de20f11e"
                },
                {
                    "nome": "Agendar Serviço",
                    "icone": "bs-agendar-servico",
                    "rota": "Profissionais",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "61dc81dba03040a8d1d49799442dfe87"
                },
                {
                    "nome": "Agendamentos",
                    "icone": "bs-meus-agendamentos",
                    "rota": "Agendamentos",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "cb3acfd09d67028ac68277ffd88701fc"
                },
                {
                    "nome": "Dicas de Saúde e Bem-Estar",
                    "icone": "bs-dicas-saude",
                    "rota": "Posts",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "15a822d6fb1d8d4bac64c3818b849204"
                },
                {
                    "nome": "Receitas",
                    "icone": "bs-receitas",
                    "rota": "Receitas",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "302abbfe87cdff659dec5cae15554d30"
                },
                {
                    "nome": "Atestados",
                    "icone": "bs-atestados",
                    "rota": "Atestados",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "adadfe394bc77e567e2f380cbfb06231"
                },
                {
                    "nome": "Meus Exames",
                    "icone": "bs-exames",
                    "rota": "Exames",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "87b5c380c54e71786942d5f42ce578fa"
                },
                {
                    "nome": "Orçamento",
                    "icone": "bs-orcamento",
                    "rota": "FinanceiroMovimentacoes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "ddffc17de440090251869080b543a2cd"
                },
                {
                    "nome": "Aprovações",
                    "icone": "bs-aprovacoes",
                    "rota": "FinanceiroSolicitacoes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "0c30479bacf9eff11abe235236132e63"
                },
                {
                    "nome": "Minha Conta",
                    "icone": "bs-minha-conta",
                    "rota": "Conta",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "69477e8ac4e4ac0b8aee7ea7f7baf856"
                },
                {
                    "nome": "Acessar Site",
                    "tipo": "link",
                    "icone": "bs-site",
                    "condicao": "true",
                    "link": "https://app.appmed.me",
                    "inicio": false,
                    "sidebar": true,
                    "id": "a8db16db41bbbc275678a7e0594cfedc"
                },
                {
                    "nome": "Termos de Uso",
                    "tipo": "modal",
                    "modal": "modal-termos-de-uso",
                    "condicao": "true",
                    "icone": "la-file-contract",
                    "inicio": false,
                    "mostrar": true,
                    "sidebar": true,
                    "id": "74cb9935c1a63ab095c5bfac0e249b14"
                },
                {
                    "nome": "Política de Privacidade",
                    "tipo": "modal",
                    "modal": "modal-politicas-de-privacidade",
                    "condicao": "true",
                    "icone": "la-file-invoice",
                    "inicio": false,
                    "mostrar": true,
                    "sidebar": true,
                    "id": "530e4c59df00b5d85794ead1c88326ae"
                }
            ],
            "controladoria": [
                {
                    "nome": "Meus Documentos",
                    "icone": "bs-meus-documentos",
                    "rota": "Arquivos",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "6d01e56a573ccc6c3a662a968edfbc65"
                },
                {
                    "nome": "GED",
                    "icone": "bs-meus-documentos",
                    "rota": "Ged",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "52905a3a61216a8678be1b91133363b3"
                },
                {
                    "nome": "Formulários",
                    "icone": "bs-formularios",
                    "rota": "PendentesFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "567b482862232c9c9501faaa3487b5b0"
                },
                {
                    "nome": "Pacientes",
                    "icone": "bs-pacientes",
                    "rota": "Pacientes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "aef7c1c2b6f3426546ef929dbde63313"
                },
                {
                    "nome": "Agendamentos",
                    "icone": "bs-meus-agendamentos",
                    "rota": "Agendamentos",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "d43b463d758fd3fb05ae0844ce3b881a"
                },
                {
                    "nome": "Receitas",
                    "icone": "bs-receitas",
                    "rota": "Receitas",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "6ded167865b5a228760e5673ec092cfe"
                },
                {
                    "nome": "Atestados",
                    "icone": "bs-atestados",
                    "rota": "Atestados",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "7a63820039fa85f14ed24ef16ff2989a"
                },
                {
                    "nome": "Orçamento",
                    "icone": "bs-orcamento",
                    "rota": "FinanceiroMovimentacoes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "16a509df2527f572c3b5e39fa7c71d4b"
                },
                {
                    "nome": "Aprovações",
                    "icone": "bs-aprovacoes",
                    "rota": "FinanceiroSolicitacoes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "8602c24bfb316df14080176656f5dc9d"
                },
                {
                    "nome": "Minha Conta",
                    "icone": "bs-minha-conta",
                    "rota": "Conta",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "174c90edd0118c7a274e7343f0a44425"
                }
            ],
            "coordenador": [
                {
                    "nome": "Formulários",
                    "icone": "bs-formularios",
                    "rota": "PendentesFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "da19acc4fe01781b69328296ff805fe4"
                },
                {
                    "nome": "Pacientes",
                    "icone": "bs-pacientes",
                    "rota": "Pacientes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "dc4d14eccd1a59e761f0d998864fd1bc"
                },
                {
                    "nome": "Agendamentos",
                    "icone": "bs-meus-agendamentos",
                    "rota": "Agendamentos",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "fc56bb81ed16800ae834444023ddc0a2"
                },
                {
                    "nome": "Receitas",
                    "icone": "bs-receitas",
                    "rota": "Receitas",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "928a355c7db1486f54bba0536ae7cbd7"
                },
                {
                    "nome": "Atestados",
                    "icone": "bs-atestados",
                    "rota": "Atestados",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "36ec859db10a35a874562ba78ddfecb7"
                },
                {
                    "nome": "Orçamento",
                    "icone": "bs-orcamento",
                    "rota": "FinanceiroMovimentacoes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "855a579ec7a6bb64678cd258884bc06f"
                },
                {
                    "nome": "Aprovações",
                    "icone": "bs-aprovacoes",
                    "rota": "FinanceiroSolicitacoes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "803f0f3cfde026f2689616f8620c855c"
                },
                {
                    "nome": "Minha Conta",
                    "icone": "bs-minha-conta",
                    "rota": "Conta",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "7b8e179339e0b23dd0902fcf2c30c593"
                }
            ],
            "criacao": [
                {
                    "nome": "Usuários",
                    "icone": "bs-usuarios",
                    "rota": "UsuariosGeral",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "476dd3211123576e95b1b426cda1fc9b"
                },
                {
                    "nome": "Minha Conta",
                    "icone": "bs-minha-conta",
                    "rota": "Conta",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "929bffd8e9042e86034c88f9db522eac"
                }
            ],
            "marketing": [
                {
                    "nome": "Formulários",
                    "icone": "bs-formularios",
                    "rota": "PendentesFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "a8f911f64b94c65a614bf7ae450ad08d"
                },
                {
                    "nome": "Dicas de Saúde e Bem-Estar",
                    "icone": "bs-dicas-saude",
                    "rota": "Posts",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "32d69cb4e3f8fe691dda0864900a5149"
                },
                {
                    "nome": "Mural de Recados",
                    "icone": "bs-mural-recados",
                    "rota": "Mural",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "96225b717e34b5dc6d03d14b7eaa6b1c"
                },
                {
                    "nome": "Campanhas",
                    "icone": "bs-campanhas",
                    "rota": "Campanhas",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "6ba4c903220719f9f3efb29d6b55a564"
                },
                {
                    "nome": "Minha Conta",
                    "icone": "bs-minha-conta",
                    "rota": "Conta",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "c1e8219ff413993fbd71d50bd343a317"
                }
            ],
            "profissional-geral": [
                {
                    "nome": "Formulários",
                    "icone": "bs-formularios",
                    "rota": "PendentesFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "e9d1658afb036d414b70810298c1533c"
                },
                {
                    "nome": "Relatório de Formulários",
                    "icone": "bs-relatorio-formularios",
                    "rota": "RelatorioFormularios",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "4614437eda72ff44ac71a79fea280953"
                },
                {
                    "nome": "Pacientes",
                    "icone": "bs-pacientes",
                    "rota": "Pacientes",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "931d957358e58858ec0115f091fa315d"
                },
                {
                    "nome": "Agendamentos",
                    "icone": "bs-meus-agendamentos",
                    "rota": "Agendamentos",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "494b0b878e259373ff8fc5f406ce7cb5"
                },
                {
                    "nome": "Beira Leito",
                    "icone": "bs-beira-leito",
                    "rota": "BeiraLeito",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "003dbbfd0c5e11ff9d3f56ece1d32ff7"
                },
                {
                    "nome": "Receitas",
                    "icone": "bs-receitas",
                    "rota": "Receitas",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "e7f8fbf76b668481aa8c53cb4e46bbd9"
                },
                {
                    "nome": "Atestados",
                    "icone": "bs-atestados",
                    "rota": "Atestados",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "c6aa4299437c50bfe87e49c5cb26b1d8"
                },
                {
                    "nome": "Honorários Médicos",
                    "icone": "bs-honorarios-medicos",
                    "rota": "HonorariosMedicos",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "ae053a2bedb4f325cd68e703746fb188"
                },
                {
                    "nome": "Minha Conta",
                    "icone": "bs-minha-conta",
                    "rota": "Conta",
                    "condicao": "true",
                    "mostrar": true,
                    "inicio": true,
                    "sidebar": true,
                    "id": "1684cc253437bfd3433308a97e7ff85f"
                }
            ]
    },
    "rotas": [
        {
            "path": "/",
            "name": "Dashboard",
            "meta": {
                "title": "Início",
                "homeButton": true
            },
            "component": "components/Dashboard.vue"
        },
        {
            "path": "/login/",
            "name": "Login",
            "meta": {
                "title": "Login",
                "auth": false
            },
            "component": "components/Login.vue"
        },
        {
            "path": "/login-app/",
            "name": "LoginApp",
            "meta": {
                "title": ""
            },
            "component": "components/LoginApp.vue"
        },
        {
            "path": "/intro/",
            "name": "Introducao",
            "meta": {
                "title": "Intro"
            },
            "component": "components/Intro.vue"
        },
        {
            "path": "/cadastro/",
            "name": "Cadastro",
            "meta": {
                "title": "Cadastro",
                "auth": false
            },
            "component": "components/Cadastro.vue"
        },
        {
            "path": "/cadastro/completar",
            "name": "CompletarCadastro",
            "meta": {
                "title": "Completar Cadastro"
            },
            "component": "components/CompletarCadastro.vue"
        },
        {
            "path": "/recuperar-senha/",
            "name": "RecuperarSenha",
            "meta": {
                "title": "Recuperar Senha",
                "auth": false
            },
            "component": "components/RecuperarSenha.vue"
        },
        {
            "path": "/confirmar-agendamento/",
            "name": "ConfirmarAgendamento",
            "meta": {
                "title": "Confirmar Agendamento"
            },
            "component": "components/ConfirmarAgendamento.vue"
        },
        {
            "path": "/dicas/",
            "name": "Posts",
            "meta": {
                "title": "Dicas de Saúde e Bem-Estar",
                "backButton": true
            },
            "component": "components/Posts.vue"
        },
        {
            "path": "/dicas/cadastro/",
            "name": "CadastrarPosts",
            "meta": {
                "title": "Cadastrar Dica",
                "auth": true,
                "backButton": true,
                "level": ["marketing", "admin"]
            },
            "component": "components/GerenciarPosts.vue"
        },
        {
            "path": "/dicas/editar/",
            "name": "EditarPosts",
            "meta": {
                "title": "Editar Dica",
                "auth": true,
                "backButton": true,
                "level": ["marketing", "admin"]
            },
            "component": "components/GerenciarPosts.vue"
        },
        {
            "path": "/configuracoes/campanhas-filtros/cadastro/",
            "name": "CadastrarCampanhasFiltros",
            "meta": {
                "title": "Cadastrar Filtro",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarCampanhasFiltros.vue"
        },
        {
            "path": "/configuracoes/campanhas-filtros/editar/",
            "name": "EditarCampanhasFiltros",
            "meta": {
                "title": "Editar Filtro",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarCampanhasFiltros.vue"
        },
        {
            "path": "/configuracoes/exames/cadastro/",
            "name": "CadastrarExamesOpcoes",
            "meta": {
                "title": "Cadastrar Opção Personalizada",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarExamesOpcoes.vue"
        },
        {
            "path": "/configuracoes/exames/editar/",
            "name": "EditarExamesOpcoes",
            "meta": {
                "title": "Editar Opção Personalizada",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarExamesOpcoes.vue"
        },
        {
            "path": "/agendamentos/",
            "name": "Agendamentos",
            "meta": {
                "title": "Agendamentos",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional", "profissional-geral", "contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Agendamentos.vue"
        },
        {
            "path": "/teleconsulta/",
            "name": "Teleconsulta",
            "meta": {
                "title": "Teleconsulta",
                "auth": true,
                "backButton": true,
                "level": ["profissional", "profissional-geral", "contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Teleconsulta.vue"
        },
        {
            "path": "/agenda/",
            "name": "Agenda",
            "meta": {
                "title": "Agenda",
                "backButton": true,
                "topClass": ["transparent"],
                "hideTitle": true
            },
            "component": "components/Agenda.vue"
        },
        {
            "path": "/sintomas/",
            "name": "Sintomas",
            "meta": {
                "title": "Histórico de Sintomas",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional", "profissional-geral", "contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Sintomas.vue"
        },
        {
            "path": "/receitas/",
            "name": "Receitas",
            "meta": {
                "title": "Receitas",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional", "profissional-geral", "contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Receitas.vue"
        },
        {
            "path": "/atestados/",
            "name": "Atestados",
            "meta": {
                "title": "Atestados",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional", "profissional-geral", "contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Atestados.vue"
        },
        {
            "path": "/profissionais/",
            "name": "Profissionais",
            "meta": {
                "title": "Agendar Serviços",
                "backButton": true
            },
            "component": "components/Profissionais.vue"
        },
        {
            "path": "/mural/",
            "name": "Mural",
            "meta": {
                "title": "Mural",
                "auth": true,
                "backButton": true,
                "level": ["admin", "marketing"]
            },
            "component": "components/Mural.vue"
        },
        {
            "path": "/campanhas/",
            "name": "Campanhas",
            "meta": {
                "title": "Campanhas",
                "auth": true,
                "backButton": true,
                "level": ["admin", "marketing"]
            },
            "component": "components/Campanhas.vue"
        },
        {
            "path": "/documentos/",
            "name": "Arquivos",
            "meta": {
                "title": "Meus Documentos",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Arquivos.vue"
        },
        {
            "path": "/exames/",
            "name": "Exames",
            "meta": {
                "title": "Meus Exames",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Exames.vue"
        },
        {
            "path": "/ged/",
            "name": "Ged",
            "meta": {
                "title": "GED",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "coordenador", "controladoria", "gerente"]
            },
            "component": "components/Ged.vue"
        },
        {
            "path": "/configuracoes/",
            "name": "Configuracoes",
            "meta": {
                "title": "Configurações",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/Configuracoes.vue"
        },
        {
            "path": "/minha-conta/",
            "name": "Conta",
            "meta": {
                "title": "Minha Conta",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "admin", "profissional", "profissional-geral", "marketing", "criacao", "controladoria", "gerente", "coordenador"]
            },
            "component": "components/Conta.vue"
        },
        {
            "path": "/alterar-senha/",
            "name": "AlterarSenha",
            "meta": {
                "title": "Alterar Senha",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "admin", "profissional", "profissional-geral", "marketing", "criacao", "controladoria", "gerente", "coordenador"]
            },
            "component": "components/AlterarSenha.vue"
        },
        {
            "path": "/pacientes/",
            "name": "Pacientes",
            "meta": {
                "title": "Pacientes",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional", "profissional-geral", "controladoria", "gerente", "coordenador"],
                "options": {
                    "tipo": "contratante"
                }
            },
            "component": "components/Pacientes.vue"
        },
        {
            "path": "/formularios/relatorio",
            "name": "RelatorioFormularios",
            "meta": {
                "title": "Relatório de Formulários",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "admin", "profissional", "profissional-geral", "marketing", "criacao", "controladoria", "gerente", "coordenador"]
            },
            "component": "components/RelatorioFormularios.vue"
        },
        {
            "path": "/formularios/pendentes",
            "name": "PendentesFormularios",
            "meta": {
                "title": "Formulários",
                "auth": true,
                "backButton": true,
                "level": ["contratante", "admin", "profissional", "profissional-geral", "marketing", "criacao", "controladoria", "gerente", "coordenador"]
            },
            "component": "components/PendentesFormularios.vue"
        },
        {
            "path": "/formularios",
            "name": "Formularios",
            "meta": {
                "title": "Gerenciar Formulários",
                "auth": true,
                "backButton": true,
                "tabs": true,
                "level": ["admin"]
            },
            "component": "components/Formularios.vue"
        },
        {
            "path": "/formulario",
            "name": "Formulario",
            "meta": {
                "title": "Formulário",
                // "auth": true,
                "backButton": true
            },
            "component": "components/Formulario.vue"
        },
        {
            "path": "/formularios/cadastro",
            "name": "CadastrarFormularios",
            "meta": {
                "title": "Criar Formulário",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarFormularios.vue"
        },
        {
            "path": "/formularios/editar",
            "name": "EditarFormularios",
            "meta": {
                "title": "Editar Formulário",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarFormularios.vue"
        },
        {
            "path": "/emitir-receita",
            "name": "GerenciarReceitas",
            "meta": {
                "title": "Emitir Receita Digital",
                "auth": true,
                "backButton": true,
                "level": ["profissional", "profissional-geral"]
            },
            "component": "components/GerenciarReceitas.vue"
        },
        {
            "path": "/pacientes/detalhes",
            "name": "Paciente",
            "meta": {
                "title": "Prontuário",
                "auth": true,
                "backButton": true,
                "level": ["profissional", "profissional-geral", "admin", "controladoria", "gerente", "coordenador"]
            },
            "component": "components/Paciente.vue"
        },
        {
            "path": "/usuarios/",
            "name": "UsuariosGeral",
            "meta": {
                "title": "Usuários",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"],
                "options": {
                    "cadastrarBotaoTexto": "Cadastrar usuário",
                    "cadastrarBotaoNome": "CadastrarUsuariosGeral",
                    "editarBotaoNome": "EditarUsuariosGeral",
                    "tipo": "admin,profissional,profissional-geral,marketing,contratante,criacao,coordenador,gerente,controladoria"
                }
            },
            "component": "components/Usuarios.vue"
        },
        {
            "path": "/areas/",
            "name": "Areas",
            "meta": {
                "title": "Áreas",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/Areas.vue"
        },
        {
            "path": "/areas/cadastro",
            "name": "CadastrarAreas",
            "meta": {
                "title": "Cadastrar Área",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/GerenciarAreas.vue"
        },
        {
            "path": "/areas/editar",
            "name": "EditarAreas",
            "meta": {
                "title": "Editar Área",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/GerenciarAreas.vue"
        },
        {
            "path": "/usuarios/cadastro",
            "name": "CadastrarUsuariosGeral",
            "meta": {
                "title": "Cadastrar Usuário",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/GerenciarUsuarios.vue"
        },
        {
            "path": "/usuarios/editar",
            "name": "EditarUsuariosGeral",
            "meta": {
                "title": "Editar Usuário",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/GerenciarUsuarios.vue"
        },
        {
            "path": "/pacientes/cadastro",
            "name": "CadastrarPacientes",
            "meta": {
                "title": "Cadastrar Paciente",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/GerenciarPacientes.vue"
        },
        {
            "path": "/pacientes/editar",
            "name": "EditarPacientes",
            "meta": {
                "title": "Editar Paciente",
                "auth": true,
                "backButton": true,
                "level": ["admin", "criacao"]
            },
            "component": "components/GerenciarPacientes.vue"
        },
        {
            "path": "/logs",
            "name": "Logs",
            "meta": {
                "title": "Logs",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/Logs.vue"
        },
        {
            "path": "/permissoes/visualizar-dados",
            "name": "PermissaoUsoDados",
            "meta": {
                "title": "Permissões de uso de dados",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/PermissaoUsoDados.vue"
        },
        {
            "path": "/autorizar-uso-de-dados",
            "name": "AutorizarUsoDados",
            "meta": {
                "title": "Autorizar uso de dados"
            },
            "component": "components/AutorizarUsoDados.vue"
        },
        {
            "path": "/honorarios-medicos",
            "name": "HonorariosMedicos",
            "meta": {
                "title": "Honorários Médicos",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional", "profissional-geral"]
            },
            "component": "components/HonorariosMedicos.vue"
        },
        {
            "path": "/financeiro/solicitacoes",
            "name": "FinanceiroSolicitacoes",
            "meta": {
                "title": "Aprovações",
                "auth": true,
                "backButton": true,
                "level": ["admin", "coordenador", "gerente", "controladoria"]
            },
            "component": "components/FinanceiroSolicitacoes.vue"
        },
        {
            "path": "/financeiro/solicitacoes/detalhes",
            "name": "FinanceiroSolicitacoesDetalhes",
            "meta": {
                "title": "Informações da Solicitação",
                "auth": true,
                "backButton": true,
                "level": ["admin", "coordenador", "gerente", "controladoria"]
            },
            "component": "components/FinanceiroSolicitacoesDetalhes.vue"
        },
        {
            "path": "/financeiro/movimentacoes",
            "name": "FinanceiroMovimentacoes",
            "meta": {
                "title": "Orçamento",
                "auth": true,
                "backButton": true,
                "level": ["admin", "coordenador", "gerente", "controladoria"]
            },
            "component": "components/FinanceiroMovimentacoes.vue"
        },
        {
            "path": "/chat-gpt",
            "name": "ChatGpt",
            "meta": {
                "title": "Chat GPT",
                "auth": true,
                "backButton": true,
                "level": ["admin", "coordenador", "gerente", "controladoria", "profissional"]
            },
            "component": "components/ChatGpt.vue"
        },
        {
            "path": "/beira-leito",
            "name": "BeiraLeito",
            "meta": {
                "title": "Beira leito",
                "auth": true,
                "backButton": true,
                "level": ["admin", "profissional-geral", "profissional"]
            },
            "component": "components/BeiraLeito.vue"
        },
        {
            "path": "/gerenciar-menus",
            "name": "GerenciarMenus",
            "meta": {
                "title": "Gerenciar menus",
                "auth": true,
                "backButton": true,
                "level": ["admin"]
            },
            "component": "components/GerenciarMenus.vue"
        },
        {
            "path": "/menu",
            "name": "Menu",
            "meta": {
                "title": "Menu",
                // "auth": true,
                "backButton": true,
                // "level": ["admin"]
            },
            "component": "components/Menu.vue"
        },
        {
            "path": "/painel",
            "name": "Painel",
            "meta": {
                "title": "Painel",
                "backButton": true,
                "auth": true,
                "level": [
                    "admin"
                ]
            },
            "component": "components/Painel.vue"
        }
    ]
}



//////////////////
// WEBPACK FOOTER
// ./static/config/app.js
// module id = KY5p
// module chunks = 54